"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayPlanModuleType = void 0;
/* eslint-disable require-jsdoc */
const constants_1 = require("../constants");
class DayPlanModuleType {
    constructor(userId, moduleId, moduleTitle, moduleIcon) {
        this.progress = 0.0;
        this.highestCorrectStreak = 0;
        this.estimatedCompletionTime = 0.0;
        this.actualStudyTime = 0.0;
        this.isFinished = false;
        this.isReviewFinished = false;
        this.isAcquisitionFinished = false;
        this.acquisitionTarget = 0;
        this.acquisitionProgress = 0;
        this.reviewTarget = 0;
        this.reviewProgress = 0;
        this.isAssigned = false;
        this.userId = userId;
        this.moduleId = moduleId;
        this.moduleTitle = moduleTitle;
        this.moduleIcon = moduleIcon;
        this.reviewCardIds = [];
    }
    static collectionPath(parentDayPlanDocId) {
        return `${constants_1.constants.COLLECTION_PATH_DAY_PLAN}/${parentDayPlanDocId}/${constants_1.constants.COLLECTION_PATH_DAY_PLAN_MODULE}`;
    }
    static collectionPathForDeleted(parentDayPlanDocId) {
        // eslint-disable-next-line max-len
        return `${constants_1.constants.COLLECTION_PATH_DAY_PLAN}/${parentDayPlanDocId}/${constants_1.constants.COLLECTION_PATH_DELETED_DAY_PLAN_MODULE}`;
    }
}
exports.DayPlanModuleType = DayPlanModuleType;
